import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-supplier-reg-types',
  templateUrl: 'supplier-reg-types.component.html',
  styleUrls: ['supplier-reg-types.component.css']
})
export class SupplierRegTypesComponent implements OnInit {

  public spinner :boolean = false;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/home/supplier-reg-types/supplier-reg-types.component.ts